import React from 'react';
import { LinkModel } from '../Types/LinkModel';
import styled from 'styled-components';
import { grid } from '../styling/utils/grid';
import { breakpoint } from '../styling/mixins/breakpoints';
import { text } from '../styling/mixins/typography';
import clsx from 'clsx';

interface BrandsBlockProps {
  title?: string;
  brands: BrandItem[];
  link?: LinkModel;
}

interface BrandItem {
  link: LinkModel;
  imageUrl?: string;
}

const BrandsBlock = ({ title, link, brands }: BrandsBlockProps) => {
  return (
    <div className="container pb-8 pt-6 md:pb-10 md:pt-8 lg:pb-12 lg:pt-10">
      <div className="mb-6 flex items-center justify-between md:mb-8">
        <h2>{title}</h2>
        {link && (
          <a className="text-xl underline" href={link.href}>
            {link.text}
          </a>
        )}
      </div>
      <ul
        className={clsx(
          'grid grid-cols-2 items-center justify-center gap-4 py-0 pb-2 md:grid-cols-3 lg:grid-cols-6 lg:gap-6'
        )}
      >
        {brands.map((brand) => (
          <li className="h-full" key={brand.link.text + brand.link.href}>
            <a
              className="flex h-full justify-center"
              href={brand.link.href}
              aria-label={brand.link.text}
            >
              {brand.imageUrl && (
                <img
                  className="aspect-square object-contain"
                  src={brand.imageUrl}
                  alt={brand.link.text}
                  loading="lazy"
                />
              )}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BrandsBlock;
